import apiClient from "@/app/api/client";
import { organizationTypePositionEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreateOrganizationTypePositionRequest,
	MessageData,
	OrganizationTypePosition,
	PaginatedResponse,
	PaginationParams,
	SuccessResponse,
	UpdateOrganizationTypePositionRequest,
} from "../types";

export const organizationTypePositionService = {
	async list(params?: PaginationParams): Promise<PaginatedResponse<OrganizationTypePosition>> {
		const response = await apiClient.get<PaginatedResponse<OrganizationTypePosition>>(
			organizationTypePositionEndpoints.list,
			{ params }
		);
		return response.data;
	},

	async getById(id: string): Promise<OrganizationTypePosition> {
		const url = replaceParams(organizationTypePositionEndpoints.getById, {
			id,
		});
		const response = await apiClient.get<SuccessResponse<OrganizationTypePosition>>(url);
		return response.data.data;
	},

	async create(data: CreateOrganizationTypePositionRequest): Promise<OrganizationTypePosition> {
		const response = await apiClient.post<SuccessResponse<OrganizationTypePosition>>(
			organizationTypePositionEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(
		id: string,
		data: UpdateOrganizationTypePositionRequest
	): Promise<OrganizationTypePosition> {
		const url = replaceParams(organizationTypePositionEndpoints.update, {
			id,
		});
		const response = await apiClient.patch<SuccessResponse<OrganizationTypePosition>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(organizationTypePositionEndpoints.delete, {
			id,
		});
		await apiClient.delete<SuccessResponse<MessageData>>(url);
	},
};
